import {api} from '../api';
import _ from 'lodash';
import {
    INVENTORY_LIST_FETCHED,
    INVENTORY_MODEL_LOADED,
    INVENTORY_MODEL_UPDATED_BY_FORM,
    INVENTORY_MODEL_UPDATED_ON_SERVER,
    SET_NEW_INVENTORY_ADJUSTMENT_MODEL,
    INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM
} from './types';

export const fetchInventories = (jwt,params) => (dispatch) => {
    return api.inventory.fetch(jwt, params).then(res => {
        dispatch({
            type: INVENTORY_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const resetInventoryModelInStore = () => {
    return ({
        type: INVENTORY_MODEL_LOADED,
        payload: {}
    })
}

export const loadInventoryById = (jwt, id) => (dispatch) => {
    if (_.isInteger(parseInt(id))) {
        return api.inventory.loadModel(jwt, id).then( res => {
            const {data} = res.data;
            data.cost = Math.round(data.cost * 1000) / 1000;
            data.selling = Math.round(data.selling * 1000) / 1000;
            dispatch({
                type: INVENTORY_MODEL_LOADED,
                payload: data
            })
        }).catch( err => {
            throw err
        })
    } else {
        dispatch({
            type: INVENTORY_MODEL_LOADED,
            payload: {
                id: null,
                type: 'Inventory',
                sku: '',
                name: '',
                woo_id: null,
                acct_id: null,
                upc: '',
                description: '',
                cost: '',
                selling: '',
                status: 'Active',
                custom_1: '',
                custom_2: '',
                custom_3: '',
                hs_code: '',
                custom_name: '',
                composition: '',
                custom_value: '',
                qty_warehouse_instock:[],
                qty_warehouse_reserved: [],
                shipment_lines: []
            }
        })
    }
}


export const updateInventoryModelInStore = (field, value) => {
    return ({
        type: INVENTORY_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}

export const updateOrCreateInventory = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.inventory.update(jwt, model).then(res => {
            dispatch({
                type: INVENTORY_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.inventory.create(jwt, model).then(res => {
            const {data} = res.data;
            data.qty_warehouse_instock = [];
            data.qty_warehouse_reserved = [];
            data.shipment_lines = [];
            dispatch({
                type: INVENTORY_MODEL_LOADED,
                payload: data
            })
            return res;
        }).catch(err => {throw err})
    }
}

export const setNewAdjustmentModel = (inventoryId) => {
    return ({
        type: SET_NEW_INVENTORY_ADJUSTMENT_MODEL,
        payload: {
            fromWarehouse: "",
            toWarehouse: "",
            id: inventoryId,
            changeQty: 1
        }
    })
}

export const updateAdjustmentModelInStore = (field, value) => {
    return({
        type: INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM,
        payload: {
            field, value
        }
    });
}

export const createInventoryAdjustment = (jwt, adjustmentModel) => (dispatch) => {
    return api.inventory.adjust(jwt, adjustmentModel);
}


// WEBPACK FOOTER //
// ./src/actions/inventory.js